<template>
			<v-container fluid>
					<v-data-iterator :items="results" :footer-props="{'items-per-page-options': [24, 48, 72, 96]}" :items-per-page="itemsPerPage" :page="page" :search="search" :sort-by="sortBy + 'Name'" :sort-desc="sortDesc">
					<template v-slot:header>
						<v-toolbar dark color="primary" class="mb-1">
							<v-text-field v-model="search" clearable solo-inverted hide-details flat prepend-inner-icon="search" label="Filter"></v-text-field>
							<template v-if="$vuetify.breakpoint.mdAndUp">
								<v-spacer></v-spacer>
								<v-select v-model="sortBy" flat solo-inverted hide-details :items="keys" prepend-inner-icon="search" label="Sort by"></v-select>
								<v-spacer></v-spacer>
								<v-btn-toggle v-model="sortDesc" mandatory>
									<v-btn large depressed color="primary" :value="false">
										<v-icon>mdi-arrow-up</v-icon>
									</v-btn>
									<v-btn large depressed color="primary" :value="true">
										<v-icon>mdi-arrow-down</v-icon>
									</v-btn>
								</v-btn-toggle>
								<v-spacer></v-spacer>
								<v-tooltip bottom v-if="results.length">
									<template v-slot:activator="{ on }">
										<v-btn icon v-on="on" v-on:click="$emit('export-data')" class="float-right">
											<v-icon>mdi-export</v-icon>
										</v-btn>
									</template>
									<span>Export as CSV</span>
								</v-tooltip>
							</template>
						</v-toolbar>
					</template>

					<template v-slot:default="props">
						<v-row>
							<v-col
								v-for="item in props.items"
								:key="item.id"
								cols="12"
								sm="6"
								md="6"
								lg="4"
							>

									<v-card >

									<template v-if="agg">
										<v-toolbar dense :elevation="1">
											<v-toolbar-title v-if="agg == 'SchoolName'" class="subheading font-weight-bold">{{ item.SchoolName[0] }}</v-toolbar-title>
											<v-toolbar-title v-if="agg == 'CountryName'" class="subheading font-weight-bold">{{ item.CountryName[0] }}</v-toolbar-title>
											<v-toolbar-title v-if="agg == 'LicenseeName'" class="subheading font-weight-bold">{{ item.LicenseeName[0] }}</v-toolbar-title>
											<v-toolbar-title v-if="agg == 'FactoryName'" class="subheading font-weight-bold">{{ item.FactoryName[0] }}</v-toolbar-title>
											<v-spacer></v-spacer>
											<ResultSetModal :item="item" :agg ="agg"/>
										</v-toolbar>
									</template>

									<templatev v-else>
										<v-toolbar dense :elevation="1">
											<v-toolbar-title class="subheading font-weight-bold">{{ item.FactoryName }}</v-toolbar-title>
											<v-spacer></v-spacer>
											<ResultSetModal :item="item" />
										</v-toolbar>
									</templatev>


									<!-- Card Content -->
									<v-divider></v-divider>
									<v-list dense>
										<v-list-item>
											<v-list-item-content :class="{ 'blue--text': (sortBy + 'Name') == key }">Disclosure Date:</v-list-item-content>
											<v-list-item-content>{{ displayDate(item) }}</v-list-item-content>
										</v-list-item>
									</v-list>
									<v-divider></v-divider>

									<v-list dense>
										<v-list-item
											v-for="(key, index) in [
											'FactoryName',
											'LicenseeName',
											'CountryName',
											]"
											:key="index"
										>
											<v-list-item-content :class="{ 'blue--text': (sortBy + 'Name') == key }">{{ getLabel(key) }}:</v-list-item-content>
											<template v-if="Array.isArray(item[key])">
												<v-list-item-content class="align-end" :class="{ 'blue--text': (sortBy + 'Name') == key }">{{ reduceArray(item[key]) }}</v-list-item-content>
											</template>
											<template v-else>
												<v-list-item-content class="align-end" :class="{ 'blue--text': (sortBy + 'Name') == key }">{{ item[key] }}</v-list-item-content>
											</template>
										</v-list-item>
									</v-list>
									<v-divider></v-divider>

									<v-expansion-panels>
										<v-expansion-panel>
										<v-expansion-panel-header>
											<h3>School</h3>
										</v-expansion-panel-header>
										<v-expansion-panel-content>
											<v-list v-if="item.SchoolName" dense>
												<template v-if="Array.isArray(item.SchoolName)">
													<v-list-item>
														<v-list-item-content>{{ reduceArraySchool(item.SchoolName) }}</v-list-item-content>
													</v-list-item>
												</template>
												<template v-else>
													<v-list-item v-for="school in item.SchoolName.split(',')" :key="school">
														<v-list-item-content>{{ school}}</v-list-item-content>
													</v-list-item>
												</template>

											</v-list>
										</v-expansion-panel-content>
										</v-expansion-panel>
									</v-expansion-panels>
									<v-divider></v-divider>

										<v-expansion-panels>
											<v-expansion-panel>
												<v-expansion-panel-header>
													<h3>Address & Contact Info</h3>
												</v-expansion-panel-header>
												<v-expansion-panel-content>
													<v-list dense>
														<v-list-item
															v-for="(key, index) in [
															'ContactName',
															'ContactPhone',
															'ContactEmail',
															'ContactFax',
															]"
															:key="index"
														>
															<v-list-item-content :class="{ 'blue--text': sortBy === key }">{{ getLabel(key) }}:</v-list-item-content>
															<template v-if="Array.isArray(item[key])">
																<v-list-item-content class="align-end" :class="{ 'blue--text': (sortBy + 'Name') == key }">{{ reduceArray(item[key]) }}</v-list-item-content>
															</template>
															<template v-else>
																<v-list-item-content class="align-end" :class="{ 'blue--text': (sortBy + 'Name') == key }">{{ item[key] }}</v-list-item-content>
															</template>
														</v-list-item>
														<v-list-item>
															<v-list-item-content :class="{ 'blue--text': sortBy === key }">Address:</v-list-item-content>
															<template v-if="Array.isArray(item.Address1)">
																<v-list-item-content class="align-end" :class="{ 'blue--text': sortBy === key }">
																{{ reduceArray(item.Address1) }}<br />
																{{ reduceArray(item.City) }}, {{ reduceArray(item.State) }} {{ reduceArray(item.Zip) }}</v-list-item-content>
															</template>
															<template v-else>
																<v-list-item-content class="align-end" :class="{ 'blue--text': sortBy === key }">
																{{ item.Address1 }}<br />
																{{ item.Address2 }}<br v-if="item.Address2" />
																{{ item.Address3 }}<br v-if="item.Address3" />
																{{ item.City }}, {{ item.State }} {{ item.Zip }}</v-list-item-content>
															</template>

														</v-list-item>
													</v-list>
												</v-expansion-panel-content>
											</v-expansion-panel>
										</v-expansion-panels>



									<v-divider></v-divider>


									<v-expansion-panels>
										<v-expansion-panel>
										<v-expansion-panel-header>
											<h3>Products</h3>
										</v-expansion-panel-header>
										<v-expansion-panel-content>
											<v-list v-if="item.Products" dense>
												<template v-if="Array.isArray(item.Products)">
													<v-list-item>
														<v-list-item-content>{{ reduceArray(item.Products) }}</v-list-item-content>
													</v-list-item>
												</template>
												<template v-else>
													<v-list-item v-for="product in item.Products.split(',')" :key="product">
														<v-list-item-content>{{ product }}</v-list-item-content>
													</v-list-item>
												</template>

											</v-list>
										</v-expansion-panel-content>
										</v-expansion-panel>
									</v-expansion-panels>
									<v-divider></v-divider>

									<v-expansion-panels>
										<v-expansion-panel>
										<v-expansion-panel-header>
											<h3>Business Type</h3>
										</v-expansion-panel-header>
										<v-expansion-panel-content>
											<v-list v-if="item.BusAssocs" dense>
												<template v-if="Array.isArray(item.BusAssocs)">
													<v-list-item>
														<v-list-item-content>{{ reduceArray(item.BusAssocs) }}</v-list-item-content>
													</v-list-item>
												</template>
												<template v-else>
													<v-list-item v-for="assoc in item.BusAssocs.split(',')" :key="assoc">
														<v-list-item-content>{{ assoc }}</v-list-item-content>
													</v-list-item>
												</template>
											</v-list>
										</v-expansion-panel-content>
										</v-expansion-panel>
									</v-expansion-panels>
									<v-divider light></v-divider>
								</v-card>
							</v-col>
						</v-row>
					</template>
				</v-data-iterator>
			</v-container>
</template>
<script>
import ResultSetModal from './ResultSetModal';
import _ from 'lodash';


export default {
	data: function () {
		return {
				search: '',
				filter: {},
				sortDesc: false,
				page: 1,
				itemsPerPage: 48,
				sortBy: 'Factory',
				keys: [ 'Factory', 'School', 'Licensee', 'Country']
		};
	},
	components: {
		ResultSetModal
	},
	props: ["results", "agg"],
	computed: {
		numberOfPages () {
			return Math.ceil(this.items.length / this.itemsPerPage);
		},
		filteredKeys () {
			return this.keys.filter(key => key !== `Name`);
		}
	},
	methods: {
		nextPage () {
			if (this.page + 1 <= this.numberOfPages) this.page += 1;
		},
		formerPage () {
			if (this.page - 1 >= 1) this.page -= 1;
		},
		updateItemsPerPage (number) {
			this.itemsPerPage = number;
		},
		getLabel (key) {
			let labels = {
			'FactoryName': 'Factory',
			'LicenseeName': 'Licensee',
			'SchoolName': 'School',
			'CountryName': 'Country',
			'ContactName': 'Contact',
			'ContactPhone': 'Phone',
			'ContactFax': 'Fax',
			'ContactEmail': 'Email'
		};
		return labels[key] ? labels[key] : key;
		},
		displayDate (item) {
			if(Array.isArray(item.DisclosureDate)){
				let dateArray = [];
				for( let i = 0; i < item.DisclosureDate.length; i++){
					let [year, month, day] = (item.DisclosureDate[i]).replace(/T.*$/, '').split('-'),
							date = `${month}/${day}/${year}`;
					dateArray.push(date);
				}
				return this.reduceArray(dateArray)
			}
			let [year, month, day] = (item.DisclosureDate).replace(/T.*$/, '').split('-'),
					date = `${month}/${day}/${year}`;
			return date;
		},

		reduceArray (item){
			let uniqueArray = _.uniq(item)
			if(uniqueArray.length > 3){
				return uniqueArray.slice(0, 3).join(', ') + ('...')
			}
			return uniqueArray.slice(0, 3).join(', ')
		},

		reduceArraySchool (item){
			return _.uniq(item).join(', ')
        }
	}
}
</script>
<style>
.controls {
	padding: 1em;
}
h4 {
	padding: 1em 0 1em 1.5em;
}
</style>
